// ---------------------------------------------------------------------------
// Phase 5C.2 — Hindi translations, keyed by the exact English UI string.
// ONLY static UI strings live here. Guest-generated content (names, captions,
// comments, song titles, food names, announcements) must NEVER be added.
// Missing entries fall back to English automatically.
// ---------------------------------------------------------------------------
export const HI = {
  // ---- Global / nav ----
  "Home": "होम",
  "Feed": "फ़ीड",
  "Requests": "ऑर्डर",
  "Games": "गेम्स",
  "More": "और",
  "Schedule": "कार्यक्रम",
  "Music": "संगीत",
  "Help": "सहायता",
  "Food": "भोजन",
  "Drinks": "पेय",
  "Map": "नक्शा",
  "Photo Q": "फोटो लाइन",
  "Embroidery": "कढ़ाई",
  "Livestream": "लाइव स्ट्रीम",
  "Language": "भाषा",
  "My Table": "मेरी टेबल",
  "Leave": "बाहर",
  "Send": "भेजें",
  "Submit": "जमा करें",
  "Cancel": "रद्द करें",
  "Close": "बंद करें",
  "Delete": "हटाएँ",
  "Save": "सहेजें",
  "Add": "जोड़ें",
  "Back": "वापस",
  "Next": "अगला",
  "Done": "पूर्ण",
  "Loading…": "लोड हो रहा है…",
  "welcome": "स्वागत",
  "tonight": "आज रात",
  "up next": "अगला",
  "announcements": "घोषणाएँ",
  "announcement": "घोषणा",
  "live": "लाइव",
  "live feed": "लाइव फ़ीड",
  "tonight at": "आज रात",
  "Welcome to the celebration": "समारोह में आपका स्वागत है",

  // ---- Guest Home ----
  "quick reorder": "फिर से ऑर्डर करें",
  "your last bite": "आपका पिछला ऑर्डर",
  "Again": "दोबारा",
  "Request assistance": "सहायता माँगें",
  "Get wedding alerts": "शादी की सूचनाएँ पाएँ",
  "Enable alerts": "सूचनाएँ चालू करें",
  "Not now": "अभी नहीं",
  "Reminders for shuttles, photos, favors, games, and wedding moments.": "शटल, फोटो, उपहार, गेम्स और शादी के खास पलों की याद दिलाने के लिए।",

  // ---- Cocktails ----
  "signature cocktails tonight": "आज रात के विशेष कॉकटेल",
  "Please order drinks at the bar.": "कृपया पेय बार पर ऑर्डर करें।",
  "Bride's Pick": "दुल्हन की पसंद",
  "Groom's Pick": "दूल्हे की पसंद",
  "Bride Recommendation": "दुल्हन की सिफ़ारिश",
  "Groom Recommendation": "दूल्हे की सिफ़ारिश",

  // ---- Schedule ----
  "Tonight's schedule": "आज रात का कार्यक्रम",
  "Current": "वर्तमान",
  "Upcoming": "आगामी",
  "Completed": "पूर्ण",

  // ---- Table ----
  "My table": "मेरी टेबल",
  "you are at": "आप यहाँ हैं",
  "Seat": "सीट",
  "Your table assignment is not currently available.": "आपकी टेबल की जानकारी अभी उपलब्ध नहीं है।",
  "View My Table on Map": "नक्शे पर मेरी टेबल देखें",
  "Guests at your table": "आपकी टेबल के मेहमान",
  "Directions": "दिशा-निर्देश",

  // ---- Food / Menu ----
  "Food & menu": "भोजन और मेन्यू",
  "Kitchen Requests": "रसोई अनुरोध",
  "your requests": "आपके अनुरोध",
  "your orders": "आपके ऑर्डर",
  "custom food request": "विशेष भोजन अनुरोध",
  "e.g. Extra naan, gluten-free portion, kid's plate": "जैसे: अतिरिक्त नान, ग्लूटेन-मुक्त, बच्चों की थाली",
  "Notes (optional)": "टिप्पणी (वैकल्पिक)",
  "Send to kitchen": "रसोई को भेजें",
  "What do you need?": "आपको क्या चाहिए?",
  "Sent to the kitchen": "रसोई को भेज दिया गया",
  "Menu is being prepared…": "मेन्यू तैयार हो रहा है…",
  "All": "सभी",
  "new": "नया",
  "accepted": "स्वीकृत",
  "in progress": "प्रगति में",
  "delivered": "पहुँचा दिया",
  "cancelled": "रद्द",

  // ---- Feed ----
  "Live feed": "लाइव फ़ीड",
  "Say something…": "कुछ लिखें…",
  "Share": "साझा करें",
  "Sharing…": "साझा हो रहा है…",
  "Preparing photo…": "फोटो तैयार हो रही है…",
  "Add a caption or photo": "कैप्शन या फोटो जोड़ें",
  "Shared!": "साझा हो गया!",
  "Comment…": "टिप्पणी…",
  "Like": "पसंद",
  "Comment": "टिप्पणी",
  "Upload Photo": "फोटो अपलोड करें",
  "Write a caption": "कैप्शन लिखें",
  "Add photo": "फोटो जोड़ें",
  "Choose photo": "फोटो चुनें",
  "Change photo": "फोटो बदलें",
  "Remove": "हटाएँ",
  "Hide": "छिपाएँ",
  "Restore": "बहाल करें",

  // ---- Music ----
  "Music requests": "संगीत अनुरोध",
  "No requests yet — be the first.": "अभी कोई अनुरोध नहीं — पहले बनें।",
  "Search for a song…": "गाना खोजें…",
  "Search": "खोजें",
  "Request this song": "यह गाना अनुरोध करें",
  "Request": "अनुरोध करें",
  "Song request sent!": "गाने का अनुरोध भेज दिया गया!",
  "Requested": "अनुरोधित",
  "Queued": "कतार में",
  "Played": "बजाया गया",
  "Searching…": "खोज रही है…",
  "No results. Try a different search.": "कोई परिणाम नहीं। कुछ और खोजें।",

  // ---- Games hub ----
  "Couple Crossword": "कपल क्रॉसवर्ड",
  "Who Will?": "कौन करेगा?",
  "Play": "खेलें",
  "Continue": "जारी रखें",
  "View Results": "परिणाम देखें",
  "Join": "जुड़ें",
  "Join the fun": "मज़े में शामिल हों",
  "Live": "लाइव",
  "Not Started": "शुरू नहीं हुआ",
  "Solve the couple's mini crossword. One official attempt — the timer starts when you press Begin.": "कपल की मिनी क्रॉसवर्ड हल करें। एक आधिकारिक प्रयास — 'शुरू करें' दबाते ही टाइमर चालू हो जाएगा।",

  // ---- Crossword ----
  "Begin": "शुरू करें",
  "Across": "आड़ी",
  "Down": "खड़ी",
  "Hint": "संकेत",
  "Hints": "संकेत",
  "Score": "स्कोर",
  "Timer": "टाइमर",
  "Time": "समय",
  "Leaderboard": "लीडरबोर्ड",
  "Submit Answers": "उत्तर जमा करें",
  "Partial Submit": "आंशिक जमा करें",
  "Congratulations!": "बधाई हो!",
  "Congratulations": "बधाई हो",
  "Your Score": "आपका स्कोर",
  "Final Score": "अंतिम स्कोर",
  "FINAL SCORE": "अंतिम स्कोर",
  "Rank": "रैंक",
  "Correct": "सही",
  "How to play": "कैसे खेलें",
  "Prize": "पुरस्कार",
  "Top the leaderboard and win a prize.": "लीडरबोर्ड में शीर्ष पर रहें और पुरस्कार जीतें।",

  // ---- Who Will ----
  "Vote": "वोट करें",
  "Results": "परिणाम",
  "Waiting for the next question…": "अगले प्रश्न की प्रतीक्षा…",
  "The game has not started yet.": "गेम अभी शुरू नहीं हुआ है।",
  "Vote recorded!": "वोट दर्ज हो गया!",

  // ---- Help ----
  "Need help?": "सहायता चाहिए?",
  "Need a server": "सर्वर चाहिए",
  "Spill / cleanup": "कुछ गिरा / सफाई",
  "Broken glass": "टूटा हुआ काँच",
  "Lost item": "खोई हुई वस्तु",
  "Maintenance": "रख-रखाव",
  "Other": "अन्य",
  "Anything we should know?": "कुछ और बताना चाहेंगे?",
  "attach a photo (optional)": "फोटो जोड़ें (वैकल्पिक)",
  "Sending…": "भेजा जा रहा है…",
  "Send to coordinator": "समन्वयक को भेजें",
  "Help is on the way": "सहायता आ रही है",

  // ---- Photo queue ----
  "Photo Queue": "फोटो लाइन",
  "Join photo queue": "फोटो लाइन में जुड़ें",
  "Leave queue": "लाइन छोड़ें",
  "Your position": "आपका स्थान",
  "Estimated wait": "अनुमानित प्रतीक्षा",
  "min": "मिनट",
  "Waiting": "प्रतीक्षा में",
  "In Progress": "प्रगति में",
  "You're in the queue!": "आप लाइन में हैं!",

  // ---- Language picker ----
  "UI labels translate; event content stays in the original.": "इंटरफ़ेस लेबल अनुवादित होते हैं; कार्यक्रम की सामग्री मूल भाषा में रहती है।",
  "selected": "चयनित",

  // ---- Landing ----
  "JOIN THE NIGHT": "रात में शामिल हों",
  "Welcome, friend": "स्वागत है, मित्र",
  "No app, no password — just your name.": "ऐप नहीं, पासवर्ड नहीं — बस आपका नाम।",
  "Full name (as on your invitation)": "पूरा नाम (निमंत्रण के अनुसार)",
  "Step inside": "अंदर आइए",
  "Live food & drink, music, games, photos.": "लाइव भोजन-पेय, संगीत, गेम्स, फोटो।",
  "SHARE THIS APP · QR": "यह ऐप साझा करें · QR",
  "VENDOR SIGN IN": "वेंडर साइन इन",
  "TONIGHT AT": "आज रात",

  // ---- Staff shared (StaffShell etc.) ----
  "Sign out": "साइन आउट",
  "Signing you in…": "साइन इन हो रहा है…",
  "Username": "उपयोगकर्ता नाम",
  "Password": "पासवर्ड",
  "Sign in": "साइन इन",
  "Refresh": "रीफ़्रेश",
  "Accept": "स्वीकारें",
  "Reject": "अस्वीकारें",
  "Complete": "पूर्ण करें",
  "Start": "शुरू करें",
  "Pause": "रोकें",
  "Resume": "जारी करें",
  "Status": "स्थिति",
  "Actions": "क्रियाएँ",
  "Notes": "टिप्पणियाँ",
  "Table": "टेबल",
  "Guest": "मेहमान",
  "Guests": "मेहमान",
  "Queue": "कतार",
  "Inventory": "सूची",
  "Pause Queue": "कतार रोकें",
  "Resume Queue": "कतार जारी करें",
  "Announcements": "घोषणाएँ",
  "Moderation": "मॉडरेशन",
  "Controls": "नियंत्रण",
  "Agenda": "एजेंडा",
  "Dashboard": "डैशबोर्ड",
  "Show": "शो",
  "Alerts": "सूचनाएँ",
  "Readiness": "तैयारी",
  "Operations Dashboard": "संचालन डैशबोर्ड",

  // ---- Phase 5C.2 additions: dynamic values (statuses, rules, states) ----
  "requested": "अनुरोधित",
  "queued": "कतार में",
  "played": "बजाया गया",
  "rejected": "अस्वीकृत",
  "pending": "लंबित",
  "PENDING": "लंबित",
  "IN PROGRESS": "प्रगति में",
  "PRE-DELIVERED": "पहले से वितरित",
  "CANCELLED": "रद्द",
  "You get one official attempt": "आपको एक आधिकारिक प्रयास मिलता है",
  "Your timer starts when you press Begin": "'शुरू करें' दबाते ही आपका टाइमर चालू हो जाता है",
  "Complete as many clues as you can": "जितने संकेत हल कर सकें, करें",
  "You may submit a partially completed puzzle": "आप आंशिक रूप से पूरी पहेली भी जमा कर सकते हैं",
  "Correct answers earn points": "सही उत्तरों पर अंक मिलते हैं",
  "Hints reduce your score": "संकेत लेने से स्कोर घटता है",
  "Your final point total goes toward the leaderboard": "आपका अंतिम स्कोर लीडरबोर्ड में जुड़ता है",
  "The guest at the top of the leaderboard wins a prize": "लीडरबोर्ड में शीर्ष मेहमान पुरस्कार जीतता है",

  // ---- Guest app additions ----
  "of": "में से",
  "or": "या",
  "and": "और",
  "points": "अंक",
  "saved": "सहेजा गया",
  "When the MC starts the game, vote live for": "जब MC गेम शुरू करें, लाइव वोट करें:",
  "That's a wrap on Who Will — thanks for playing!": "'कौन करेगा?' समाप्त — खेलने के लिए धन्यवाद!",
  "The MC hasn't started the game yet. Stay tuned!": "MC ने अभी गेम शुरू नहीं किया है। बने रहें!",
  "CURRENT QUESTION": "वर्तमान प्रश्न",
  "Voting opens soon…": "वोटिंग जल्द शुरू होगी…",
  "VOTING IS OPEN": "वोटिंग चालू है",
  "Voting Closed": "वोटिंग बंद",
  "Vote submitted": "वोट जमा हो गया",
  "you can still change it": "आप इसे अब भी बदल सकते हैं",
  "Song requested": "गाना अनुरोधित",
  "Search songs, artist, album or genre...": "गाना, कलाकार, एल्बम या शैली खोजें...",
  "searching…": "खोज जारी…",
  "Search is unavailable right now — you can still type your song and request it.": "खोज अभी उपलब्ध नहीं है — आप गाना लिखकर अनुरोध कर सकते हैं।",
  "Requesting…": "अनुरोध हो रहा है…",
  "Request Song": "गाना अनुरोध करें",
  "any moment": "किसी भी क्षण",
  "You're in! We'll let you know when it's almost your turn.": "आप शामिल हो गए! आपकी बारी आने पर हम बताएँगे।",
  "You left the queue": "आपने लाइन छोड़ दी",
  "Photo with the couple": "कपल के साथ फोटो",
  "Skip the line — join the virtual queue and we'll buzz you when it's almost your turn.": "लाइन में खड़े न हों — वर्चुअल कतार में जुड़ें, बारी आने पर हम सूचित करेंगे।",
  "Join the queue": "कतार में जुड़ें",
  "Photo queue": "फोटो कतार",
  "it's your turn": "आपकी बारी है",
  "Smile!": "मुस्कुराइए!",
  "you're up next": "अगली बारी आपकी है",
  "Head over now": "अभी पहुँचें",
  "your position": "आपका स्थान",
  "Signature Cocktail": "विशेष कॉकटेल",
  "Alcoholic": "एल्कोहॉलिक",
  "Non-Alcoholic": "नॉन-एल्कोहॉलिक",
  "Enabling…": "चालू हो रहा है…",
  "Alerts enabled — you'll get reminders for shuttles, favors, and moments.": "सूचनाएँ चालू — शटल, उपहार और खास पलों की याद दिलाई जाएगी।",
  "Add Venuefy to your Home Screen for background alerts: 1) Tap Share · 2) Add to Home Screen · 3) Open Venuefy from the icon · 4) Enable alerts. This is not an App Store download.": "बैकग्राउंड सूचनाओं के लिए Venuefy को होम स्क्रीन पर जोड़ें: 1) शेयर दबाएँ · 2) होम स्क्रीन पर जोड़ें · 3) आइकन से Venuefy खोलें · 4) सूचनाएँ चालू करें। यह App Store डाउनलोड नहीं है।",
  "FLAVOR PROFILE": "स्वाद प्रोफ़ाइल",
  "INGREDIENTS": "सामग्री",
  "now pouring": "अभी परोसा जा रहा है",
  "Menu Explorer": "मेन्यू एक्सप्लोरर",
  "Clear": "साफ़ करें",
  "All Stations": "सभी स्टेशन",
  "Search dishes…": "व्यंजन खोजें…",
  "dish": "व्यंजन",
  "dishes": "व्यंजन",
  "No dishes match — try adjusting search or filters.": "कोई व्यंजन नहीं मिला — खोज या फ़िल्टर बदलें।",
  "View on Map": "नक्शे पर देखें",
  "Cocktail Hour": "कॉकटेल आवर",
  "Dinner": "रात्रिभोज",
  "Desserts": "मिठाइयाँ",
  "After Party": "आफ्टर पार्टी",
  "VENUE MAP": "स्थल का नक्शा",
  "The livestream will appear here once the couple starts it.": "कपल के शुरू करते ही लाइवस्ट्रीम यहाँ दिखेगी।",
  "Ceremony": "समारोह",
  "Speech": "भाषण",
  "Dance": "नृत्य",
  "Toast": "टोस्ट",

  // ---- Crossword ----
  "COUPLE'S CROSSWORD": "कपल क्रॉसवर्ड",
  "Welcome to the Couple's Crossword": "कपल क्रॉसवर्ड में आपका स्वागत है",
  "Continue the Couple's Crossword": "कपल क्रॉसवर्ड जारी रखें",
  "Your Crossword is Submitted": "आपकी क्रॉसवर्ड जमा हो गई है",
  "Begin Crossword": "क्रॉसवर्ड शुरू करें",
  "Continue Crossword": "क्रॉसवर्ड जारी रखें",
  "IN_PROGRESS": "प्रगति में",
  "RULES": "नियम",
  "SCORING": "स्कोरिंग",
  "Starting…": "शुरू हो रहा है…",
  "Not Yet": "अभी नहीं",
  "How well do you know": "आप कितना जानते हैं",
  "Do as much as you can, then submit your crossword when you are ready. You do not need to complete every clue — correct partial answers still earn points toward the leaderboard and the prize.": "जितना हो सके हल करें, फिर तैयार होने पर जमा करें। हर संकेत पूरा करना ज़रूरी नहीं — सही आंशिक उत्तर भी लीडरबोर्ड और पुरस्कार के लिए अंक दिलाते हैं।",
  "Complete as much as you can, then submit when you are ready. Correct partial answers still earn leaderboard points.": "जितना हो सके पूरा करें, फिर तैयार होने पर जमा करें। सही आंशिक उत्तर भी लीडरबोर्ड अंक दिलाते हैं।",
  "You have completed your one official attempt. Tap below to see your score and leaderboard position.": "आपका एक आधिकारिक प्रयास पूरा हो चुका है। स्कोर और लीडरबोर्ड स्थान देखने के लिए नीचे टैप करें।",
  "The Couple Crossword has not been published yet.": "कपल क्रॉसवर्ड अभी प्रकाशित नहीं हुई है।",
  "Crossword submitted — every correct answer counted!": "क्रॉसवर्ड जमा — हर सही उत्तर गिना गया!",
  "Tap a square to begin.": "शुरू करने के लिए किसी खाने पर टैप करें।",
  "Submit Crossword?": "क्रॉसवर्ड जमा करें?",
  "Submit Partial Crossword?": "आंशिक क्रॉसवर्ड जमा करें?",
  "Your answers will be scored and your final result will be added to the leaderboard. Once submitted, your official attempt is complete.": "आपके उत्तरों का स्कोर बनेगा और अंतिम परिणाम लीडरबोर्ड में जुड़ेगा। जमा करने के बाद आपका आधिकारिक प्रयास पूर्ण हो जाएगा।",
  "You still have unanswered clues. All correct completed answers will earn points and your final score will be added to the leaderboard. Once submitted, your official attempt is complete and cannot be reopened.": "अभी कुछ संकेत अनुत्तरित हैं। सभी सही उत्तरों पर अंक मिलेंगे और अंतिम स्कोर लीडरबोर्ड में जुड़ेगा। जमा करने के बाद प्रयास दोबारा नहीं खोला जा सकता।",
  "Review Puzzle": "पहेली देखें",
  "Keep Playing": "खेलते रहें",
  "Submitting…": "जमा हो रहा है…",
  "Submit Final Answers": "अंतिम उत्तर जमा करें",
  "You only get": "आपको केवल",
  "one official attempt": "एक आधिकारिक प्रयास मिलता है",
  "Resume Puzzle": "पहेली जारी रखें",
  "Crossword Submitted": "क्रॉसवर्ड जमा हो गई",
  "Nice work — every correct answer counted toward your score.": "बहुत बढ़िया — हर सही उत्तर आपके स्कोर में गिना गया।",
  "Correct Answers": "सही उत्तर",
  "Puzzle Completion": "पहेली पूर्णता",
  "Time Used": "लगा समय",
  "Hints Used": "उपयोग किए संकेत",
  "View Leaderboard": "लीडरबोर्ड देखें",
  "Return to Games": "गेम्स पर लौटें",
  "LEADERBOARD": "लीडरबोर्ड",
  "No finishers yet — be the first.": "अभी किसी ने पूरा नहीं किया — पहले बनें।",
  "Partial": "आंशिक",

  // ---- Landing / marketing ----
  "join the night": "रात में शामिल हों",
  "Joining…": "शामिल हो रहे हैं…",
  "There is more than one of you here": "यहाँ आपके नाम के एक से अधिक मेहमान हैं",
  "Pick your table to continue.": "जारी रखने के लिए अपनी टेबल चुनें।",
  "tap to join": "जुड़ने के लिए टैप करें",
  "hide QR": "QR छिपाएँ",
  "share this app · QR": "यह ऐप साझा करें · QR",
  "point a camera": "कैमरा दिखाएँ",
  "Please enter your full name": "कृपया अपना पूरा नाम लिखें",
  "Welcome!": "स्वागत है!",
  "Vendor sign in": "वेंडर साइन इन",
  "Live Event": "लाइव कार्यक्रम",
  "Join the Waitlist": "प्रतीक्षा-सूची में जुड़ें",
  "Your Event.": "आपका कार्यक्रम।",
  "One Operating System.": "एक ऑपरेटिंग सिस्टम।",
  "Venuefy replaces spreadsheets, WhatsApp groups, radios, paper schedules, seating charts, standalone RSVP apps, DJ software, and vendor coordination with one real-time platform connecting guests, hosts, planners, vendors, coordinators, MCs, and staff.": "Venuefy स्प्रेडशीट, WhatsApp समूह, रेडियो, कागज़ी कार्यक्रम, बैठने के चार्ट, RSVP ऐप, DJ सॉफ़्टवेयर और वेंडर समन्वय — सबकी जगह एक रीयल-टाइम प्लेटफ़ॉर्म लाता है, जो मेहमानों, मेज़बानों, योजनाकारों, वेंडरों, समन्वयकों, MC और स्टाफ़ को जोड़ता है।",
  "The Problem": "समस्या",
  "Where Venuefy Sits": "Venuefy की भूमिका",
  "The Current Market": "वर्तमान बाज़ार",
  "What is an Event Operating System?": "इवेंट ऑपरेटिंग सिस्टम क्या है?",
  "Use Cases": "उपयोग के उदाहरण",
  "Features": "विशेषताएँ",
  "Roadmap": "रोडमैप",
  "Early Access": "अर्ली एक्सेस",
  "Be first in line when Venuefy opens for your events.": "Venuefy आपके कार्यक्रमों के लिए खुलते ही सबसे पहले जानें।",
  "First Name": "पहला नाम",
  "Last Name": "अंतिम नाम",
  "Email": "ईमेल",
  "Company (optional)": "कंपनी (वैकल्पिक)",
  "Type of Event": "कार्यक्रम का प्रकार",
  "Estimated Guests": "अनुमानित मेहमान",
  "Comments": "टिप्पणियाँ",
  "Tell us about your event…": "अपने कार्यक्रम के बारे में बताएँ…",

  // ---- Staff shared / login ----
  "console": "कंसोल",
  "team access": "टीम एक्सेस",
  "Signing in…": "साइन इन हो रहा है…",

  // ---- Kitchen ----
  "Kitchen line": "रसोई लाइन",
  "Tickets in real time": "रीयल-टाइम टिकट",
  "No active tickets.": "कोई सक्रिय टिकट नहीं।",
  "Mark": "चिह्नित करें:",
  "New": "नया",

  // ---- DJ ----
  "DJ booth": "DJ बूथ",
  "Add to Queue": "कतार में जोड़ें",
  "Mark Played": "बजाया गया चिह्नित करें",
  "History": "इतिहास",
  "No history yet": "अभी कोई इतिहास नहीं",
  "Empty": "खाली",

  // ---- Photographer ----
  "Photographer": "फोटोग्राफर",
  "Live photo queue": "लाइव फोटो कतार",
  "No one waiting.": "कोई प्रतीक्षा में नहीं।",
  "now taking photos": "अभी फोटो हो रही है",
  "now taking photos with": "अभी फोटो हो रही है:",

  // ---- Coordinator ----
  "Coordinator": "समन्वयक",
  "Floor in your hand": "पूरा फ़्लोर आपके हाथ में",
  "Help queue": "सहायता कतार",
  "CRITICAL": "गंभीर",
  "Take": "लें",
  "All clear.": "सब ठीक है।",
  "Announce": "घोषणा करें",
  "Announce to all guests…": "सभी मेहमानों के लिए घोषणा…",
  "Send announcement": "घोषणा भेजें",
  "other requests": "अन्य अनुरोध",
  "Mark done": "पूर्ण चिह्नित करें",
  "No other requests.": "कोई अन्य अनुरोध नहीं।",
  "Feed moderation": "फ़ीड मॉडरेशन",

  // ---- Couple ----
  "The couple's view": "कपल का व्यू",
  "Steer the night": "रात की कमान संभालें",
  "orders pending": "लंबित ऑर्डर",
  "orders delivered": "पहुँचाए गए ऑर्डर",
  "motif": "मोटिफ़",
  "Signature cocktails": "विशेष कॉकटेल",
  "tap to push to all guests": "सभी मेहमानों को भेजने के लिए टैप करें",
  "No signature cocktails configured.": "कोई विशेष कॉकटेल सेट नहीं है।",
  "DJ queue": "DJ कतार",
  "No music yet.": "अभी कोई संगीत नहीं।",
  "Projector": "प्रोजेक्टर",
  "Open projector": "प्रोजेक्टर खोलें",

  // ---- Admin ----
  "Admin console": "एडमिन कंसोल",
  "Owners-only controls": "केवल मालिकों के नियंत्रण",
  "Livestream saved": "लाइवस्ट्रीम सहेजी गई",
  "Pick a CSV first": "पहले CSV चुनें",
  "YouTube Live or Vimeo URL": "YouTube Live या Vimeo URL",
  "Title (optional)": "शीर्षक (वैकल्पिक)",
  "Save & broadcast": "सहेजें और प्रसारित करें",
  "Join QR": "जॉइन QR",
  "Open projector mode": "प्रोजेक्टर मोड खोलें",
  "Upload guest CSV": "मेहमान CSV अपलोड करें",
  "Name": "नाम",
  "Operations": "संचालन",
  "No backend exceptions, failed uploads, or failed API calls recorded.": "कोई बैकएंड त्रुटि, विफल अपलोड या विफल API कॉल दर्ज नहीं।",
  "Event Readiness": "कार्यक्रम की तैयारी",
  "Push health": "पुश स्थिति",
  "Send test alert to me": "मुझे परीक्षण सूचना भेजें",
  "Send alert": "सूचना भेजें",
  "All guests": "सभी मेहमान",
  "VIP guests": "VIP मेहमान",
  "Staff role": "स्टाफ़ भूमिका",
  "Normal": "सामान्य",
  "Emergency": "आपातकाल",
  "No alerts sent yet": "अभी कोई सूचना नहीं भेजी गई",
  "Waitlist": "प्रतीक्षा-सूची",
  "Event": "कार्यक्रम",
  "When": "कब",
  "Export CSV": "CSV निर्यात करें",
  "New remaining": "नई शेष मात्रा",
  "Reason (required)": "कारण (आवश्यक)",
  "Reason (optional)": "कारण (वैकल्पिक)",
  "Confirm": "पुष्टि करें",
  "Adjustment history": "समायोजन इतिहास",
  "No adjustments yet": "अभी कोई समायोजन नहीं",
  "VIP only": "केवल VIP",
  "Non-VIP": "गैर-VIP",
  "No guests match": "कोई मेहमान नहीं मिला",
  "Moments": "खास पल",
  "push synchronized messages to all guests": "सभी मेहमानों को एक साथ संदेश भेजें",
  "Info": "जानकारी",
  "Celebrate": "जश्न",
  "Warning": "चेतावनी",
  "scheduled": "निर्धारित",
  "recent": "हाल के",

  // ---- MC ----
  "MC console": "MC कंसोल",
  "Run the show": "शो चलाएँ",
  "DASHBOARD": "डैशबोर्ड",
  "SHOW": "शो",
  "MC Agenda": "MC एजेंडा",
  "NEXT": "अगला",
  "No agenda items.": "कोई एजेंडा आइटम नहीं।",
  "Live Feed Moderation": "लाइव फ़ीड मॉडरेशन",
  "No posts match.": "कोई पोस्ट नहीं मिली।",
  "Who Will · Live Control": "कौन करेगा · लाइव नियंत्रण",
  "No active question. Start the game to begin.": "कोई सक्रिय प्रश्न नहीं। शुरू करने के लिए गेम स्टार्ट करें।",
  "Question Set": "प्रश्न सेट",
  "No questions yet.": "अभी कोई प्रश्न नहीं।",
  "Crossword Champion Reveal": "क्रॉसवर्ड चैंपियन घोषणा",
  "No published crossword.": "कोई प्रकाशित क्रॉसवर्ड नहीं।",
  "No scored submissions yet.": "अभी कोई स्कोर की गई प्रविष्टि नहीं।",
  "GUEST": "मेहमान",
  "TABLE": "टेबल",
  "SCORE": "स्कोर",
  "CLUES": "संकेत",
  "TIME": "समय",
  "STATUS": "स्थिति",
  "PUBLIC REVEAL PREVIEW": "सार्वजनिक घोषणा पूर्वावलोकन",
  "GET READY": "तैयार हो जाइए",
  "VOTING OPEN": "वोटिंग चालू",
  "VOTING CLOSED": "वोटिंग बंद",
  "Open Poll": "पोल खोलें",
  "CORRECT": "सही",
  "TOTAL": "कुल",

  // ---- Embroidery studio ----
  "Embroidery Studio": "कढ़ाई स्टूडियो",
  "Live orders and inventory": "लाइव ऑर्डर और सूची",
  "Pashmina remaining": "पश्मीना शेष",
  "Handkerchief remaining": "रूमाल शेष",
  "Combined remaining": "कुल शेष",
  "Active orders": "सक्रिय ऑर्डर",
  "Embroidery Requests": "कढ़ाई अनुरोध",
  "OPEN": "खुला",
  "CLOSED": "बंद",
  "END QUEUE": "कतार समाप्त करें",
  "Reopen Requests": "अनुरोध फिर खोलें",
  "Edit Inventory": "सूची संपादित करें",
  "Live inventory": "लाइव सूची",
  "End the embroidery queue for the night?": "आज रात के लिए कढ़ाई कतार समाप्त करें?",
  "Reopen embroidery requests?": "कढ़ाई अनुरोध फिर खोलें?",
  "This will stop guests from submitting new embroidery requests. Existing orders will remain available for processing.": "इससे मेहमान नए कढ़ाई अनुरोध नहीं भेज पाएँगे। मौजूदा ऑर्डर प्रोसेसिंग के लिए उपलब्ध रहेंगे।",
  "Guests will be able to submit new embroidery requests again. Only colors with remaining stock will be shown.": "मेहमान फिर से नए कढ़ाई अनुरोध भेज सकेंगे। केवल शेष स्टॉक वाले रंग दिखेंगे।",
  "Saving…": "सहेजा जा रहा है…",
  "Yes, END QUEUE": "हाँ, कतार समाप्त करें",
  "Yes, reopen": "हाँ, फिर खोलें",
  "Cancel order": "ऑर्डर रद्द करें",
  "Inventory will be released back to stock.": "सूची वापस स्टॉक में जुड़ जाएगी।",
  "Keep": "रखें",
  "Requests reopened": "अनुरोध फिर खुल गए",
  "New requests stopped": "नए अनुरोध रोक दिए गए",
  "Cancelled · inventory released": "रद्द · सूची मुक्त हुई",
  "Pending": "लंबित",

  // ---- Embroidery guest flow ----
  "Live Embroidery": "लाइव कढ़ाई",
  "Embroidery is not open right now.": "कढ़ाई अभी खुली नहीं है।",
  "Favor Premade and Delivered": "उपहार पहले से तैयार और वितरित",
  "Your monogrammed favor was prepared ahead of time and is waiting for you at your seat.": "आपका मोनोग्राम उपहार पहले से तैयार है और आपकी सीट पर आपका इंतज़ार कर रहा है।",
  "Custom embroidery team has ended their queue for the night. Please grab a pashmina or handkerchief on your way out": "कढ़ाई टीम ने आज रात की कतार समाप्त कर दी है। जाते समय पश्मीना या रूमाल ले लें",
  "Text must be 1–3 characters.": "टेक्स्ट 1–3 अक्षरों का होना चाहिए।",
  "Your embroidery is queued — we'll notify you when it's ready.": "आपकी कढ़ाई कतार में है — तैयार होने पर सूचित करेंगे।",
  "Reserving…": "आरक्षित हो रहा है…",
  "Confirm & submit": "पुष्टि करें और जमा करें",
  "Item": "वस्तु",
  "Color": "रंग",
  "Thread": "धागा",
  "Text": "टेक्स्ट",
  "Review": "समीक्षा",
  "step 1 · pick your item": "चरण 1 · अपनी वस्तु चुनें",
  "step 2 · pick a color": "चरण 2 · रंग चुनें",
  "step 3 · thread color": "चरण 3 · धागे का रंग",
  "step 4 · your text": "चरण 4 · आपका टेक्स्ट",
  "step 5 · review & confirm": "चरण 5 · समीक्षा और पुष्टि",
  "Available": "उपलब्ध",
  "Currently out of stock": "अभी स्टॉक में नहीं",
  "Low": "कम",
  "left": "शेष",
  "Maximum 3 characters. Text is case-sensitive.": "अधिकतम 3 अक्षर। टेक्स्ट केस-संवेदी है।",
  "Fabric color": "कपड़े का रंग",
  "Thread color": "धागे का रंग",
  "your order": "आपका ऑर्डर",
  "COMPLETE": "पूर्ण",
  "COMPLETED": "पूर्ण",
  "Your favor is ready for pickup at the Embroidery Pickup Table.": "आपका उपहार कढ़ाई पिकअप टेबल पर तैयार है।",
  "Replace Photo": "फोटो बदलें",
  "Remove Photo": "फोटो हटाएँ",
  "Please choose an image file": "कृपया एक छवि फ़ाइल चुनें",
  "Pastes appear in the guest More → Livestream tab and on the projector.": "पेस्ट किया गया लिंक मेहमानों के 'और → लाइव स्ट्रीम' टैब और प्रोजेक्टर पर दिखेगा।",
  "Import": "आयात करें",
  "Export all data (JSON)": "सारा डेटा निर्यात करें (JSON)",
  "Hide QR": "QR छिपाएँ",
  "Show QR": "QR दिखाएँ",
};
